export enum WHITELABEL_COMPANY {
  WORLDCOIN = '6579c1d289ad6a000767524f',
  BEETRANSFER = '65bd0f55f6a4760007a00e0f',
  MENLEI = '66194c6fc2faf00007d4a59d',
  WORLDCOIN_CHL = '65b11103dc60150007d6c780',
  WORLDCOIN_COL = '66675c2dac8e0f0007bd1789',
  WORLDCOIN_BRA = '66c89c0cbaadba2976b33007',
  WORLDCOIN_GTM = '6706876e615a4fc7f16fefb0',
  WORLDCOIN_CRI = '6759b740cf0a480e4f13a340',
  WORLDCOIN_PAN = '6759b72ecf0a480e4f13a2fc',
  WORLDCOIN_MEX = '67893861910740bac4826e19',
  WORLDCOIN_PHL = '67b4c67e423ff0f11cd1c9ca',
}

export enum WIDGET_COMPANY {
  CREDIT = '677347d85f5d04632c0323c7',
}

export const ADDRESS_EVENT = '';

export interface RegisterRequest {
  address: string;
  userId: string;
  exchangeCountry?: string;
  companyId?: WHITELABEL_COMPANY;
  widgetType?: 'RAMPON' | 'RAMPOFF';
  testVariant?: boolean;
  miniapp?: boolean;
}
